function assignSwellLetter(index) {
  switch (index) {
    case 1:
      return 'A';
    case 2:
      return 'B';
    case 3:
      return 'C';
    case 4:
      return 'D';
    default:
      return '-';
  }
}
export default assignSwellLetter;
